import { css } from 'react-emotion';

export const menuListClassName = css`
  overflow: auto;
  max-height: 450px;
  width: 345px;
`;

export default { menuListClassName };
